import { render, staticRenderFns } from "./report-home.vue?vue&type=template&id=40b19e34&scoped=true"
import script from "./report-home.vue?vue&type=script&lang=js"
export * from "./report-home.vue?vue&type=script&lang=js"
import style0 from "./report-home.vue?vue&type=style&index=0&id=40b19e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b19e34",
  null
  
)

export default component.exports